import api, { mapResponseData } from 'api';

/* eslint-disable */
export const fetchAFOAdvisoriesLink = lang =>
    api.get(`/afo/advisories/${lang}`, { responseType: 'text' }).then(mapResponseData);
/* eslint-enable */
